import {
  buildRegistrationLegalDocumentHref,
  type RegistrationLegalReturnTo,
} from "../../lib/legalConsent";

type LegalConsentCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  returnTo: RegistrationLegalReturnTo;
  disabled?: boolean;
  id?: string;
};

export default function LegalConsentCheckbox({
  checked,
  onChange,
  returnTo,
  disabled = false,
  id = "registration-legal-consent",
}: LegalConsentCheckboxProps) {
  return (
    <div className="rounded-2xl border border-[#EADBC8] bg-[#FFFCFA] px-4 py-3 text-left">
      <div className="flex items-start gap-3">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
          className="mt-1 h-4 w-4 shrink-0 accent-[#7C5A4E]"
        />
        <label htmlFor={id} className="text-xs font-medium leading-6 text-[#5D4D46]">
          <a
            href={buildRegistrationLegalDocumentHref("/terms", returnTo)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-[#A67C52] underline underline-offset-2"
          >
            利用規約
          </a>
          と
          <a
            href={buildRegistrationLegalDocumentHref("/privacy", returnTo)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-[#A67C52] underline underline-offset-2"
          >
            プライバシーポリシー
          </a>
          に同意し、18歳以上であることを確認します。
        </label>
      </div>
    </div>
  );
}
